export function LoginScreen() {
  const apiUrl = import.meta.env.VITE_HOUSTON_API_URL ?? "";
  return (
    <div class="flex h-screen items-center justify-center">
      {/* Centered card */}
      <div class="panel-bezel w-[340px] p-0 text-center">
        {/* Top accent bar */}
        <div class="h-[2px] bg-gradient-to-r from-transparent via-[var(--color-info)] to-transparent opacity-60" />

        <div class="px-8 py-10">
          {/* Logo */}
          <div class="mb-1 font-display text-2xl font-black uppercase tracking-[0.4em] text-[var(--color-info)] text-glow-info">
            Houston
          </div>
          <div class="font-mono text-[9px] uppercase tracking-[0.3em] text-[var(--color-text-dim)]">
            TED Mission Control
          </div>

          {/* Divider */}
          <div class="my-8 h-[1px] bg-gradient-to-r from-transparent via-[var(--color-border-panel)] to-transparent" />

          {/* Status line */}
          <div class="mb-6 font-mono text-[10px] text-[var(--color-text-secondary)]">
            Restricted to <span class="text-[var(--color-info)]">@ted.com</span> personnel
          </div>

          {/* Auth button */}
          <a
            href={`${apiUrl}/auth/google`}
            class="group inline-flex items-center gap-2 rounded border border-[var(--color-border-accent)] px-6 py-2.5 font-mono text-[11px] uppercase tracking-[0.15em] text-[var(--color-info)] transition-all hover:border-[var(--color-info)] hover:bg-[rgba(56,189,248,0.06)] hover:shadow-[0_0_20px_rgba(56,189,248,0.15)]"
          >
            <svg class="h-3.5 w-3.5 opacity-70 transition-opacity group-hover:opacity-100" viewBox="0 0 24 24" fill="currentColor">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" />
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
            Authenticate
          </a>
        </div>
      </div>
    </div>
  );
}
